import { useHatDashboardPageContext } from '../Pages/HatDashboardPage';
import { useHatChannelTrafficTable } from '../../pages/hat/partials/Tables/HatChannelTrafficTable';
import { useHatConversionTrafficTable } from '../../pages/hat/partials/Tables/HatConversionTrafficTable';
import DateRangeUtils from '../../utils/DateRangeUtils';
import Utils from '../../components/Utils';

const useHatChannelTrafficCsvExporter = () => {
    const { rows } = useHatChannelTrafficTable();

    const getCsvData = () => {
        let _rows: any[] = [];

        rows.forEach((_row, _index) => {
            const { channel, totalUniqueTraffic, totalAdInfluencedTraffic, percentAdInfluenced } = _row;

            _rows.push([
                channel,
                ...[totalUniqueTraffic, totalAdInfluencedTraffic, percentAdInfluenced].map((metric, i) =>
                    Utils.formatValue(metric.value, i === 2 ? 'percent' : undefined)
                ),
            ]);
        });

        return _rows;
    };

    return { getCsvData };
};

const useHatConversionTrafficCsvExporter = () => {
    const { rows } = useHatConversionTrafficTable();

    const getCsvData = () => {
        let _rows: any[] = [];

        rows.forEach((_row, _index) => {
            const { conversionName, totalConversions, totalAdInfluencedConversion, percentAdInfluenced } = _row;

            _rows.push([
                conversionName,
                ...[totalConversions, totalAdInfluencedConversion, percentAdInfluenced].map((metric, i) =>
                    Utils.formatValue(metric.value, i === 2 ? 'percent' : undefined)
                ),
            ]);
        });

        return _rows;
    };

    return { getCsvData };
};

const useHatCsvExporter = () => {
    const { hatCriteria, metrics } = useHatDashboardPageContext();
    const { getCsvData: getChannelTrafficCsvData } = useHatChannelTrafficCsvExporter();
    const { getCsvData: getConversionTrafficCsvData } = useHatConversionTrafficCsvExporter();

    const getCsvData = () => {
        let rows = [];

        rows.push(['HAT Reporting Analytics - Overall Performance']);

        if (hatCriteria.mediaType) {
            rows.push(['Media Type', hatCriteria.mediaType]);
        }

        rows.push(
            ...[
                [
                    DateRangeUtils.toLabel(hatCriteria.startDate, hatCriteria.endDate),
                    // DateRangeUtils.toLabel(hatCriteria.previousStartDate, hatCriteria.previousEndDate),
                ],
            ]
        );

        rows.push(
            ...[
                [],
                ['Total Visits', 'Attributed Visits', 'Total Actions', 'Attributed Actions'],
                [
                    metrics?.TOTAL_UNIQUE_TRAFFIC?.value,
                    metrics?.TOTAL_AD_INFLUENCED_TRAFFIC?.value,
                    metrics?.TOTAL_CONVERSIONS?.value,
                    metrics?.TOTAL_AD_INFLUENCED_CONVERSIONS?.value,
                ],
            ]
        );

        rows.push(...[[], ['Visits']]);
        rows.push(...getChannelTrafficCsvData());

        rows.push(...[[], ['Actions']]);
        rows.push(...getConversionTrafficCsvData());

        return rows;
    };

    return { getCsvData };
};

export { useHatCsvExporter };
